var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainingAnswerWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3758 0.780273L12.793 10.3631L3.21011 0.780273L0.792969 3.19742L10.3758 12.7803L0.792969 22.3631L3.21011 24.7803L12.793 15.1974L22.3758 24.7803L24.793 22.3631L15.2101 12.7803L24.793 3.19742L22.3758 0.780273Z",
    fill: "#E56F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingAnswerWrong);
export default __webpack_public_path__ + "static/media/TrainingAnswerWrong.fe20170fd457677a2ecebb8ce033c274.svg";
export { ForwardRef as ReactComponent };